import Emitter from '../../mixins/emitter'

export default {
    mixins: [Emitter],

    created() {
        var event = this.$options.model && this.$options.model.event || "input"

        this.$on(event, (...args) => this.dispatch("FilterItem", "item-change", [...args]))
    }
}